import { CoaMappingRow } from "./coaMappingRowTypes";

type RowPredicate = (row: CoaMappingRow) => boolean;

function rowMatches(row: CoaMappingRow, query: string): boolean {
    return [row.name, row.sourceNumber ?? ""].some((value) =>
        value.toLowerCase().includes(query),
    );
}

// A matching group or classification keeps its whole subtree, as the editor's
// group-chain match does.
function filterRows(
    rows: CoaMappingRow[],
    isMatch: RowPredicate,
): CoaMappingRow[] {
    return rows.flatMap((row) => {
        if (isMatch(row)) {
            return [row];
        }
        if (row.account) {
            return [];
        }
        const children = filterRows(row.children ?? [], isMatch);
        return children.length > 0 ? [{ ...row, children }] : [];
    });
}

export function filterCoaMappingRows({
    rows,
    searchFilter,
}: {
    rows: CoaMappingRow[];
    searchFilter: string | undefined;
}): CoaMappingRow[] {
    const query = searchFilter?.trim().toLowerCase();
    if (!query) {
        return rows;
    }
    return filterRows(rows, (row) => rowMatches(row, query));
}

export function filterCoaMappingRowsByAccountIds({
    rows,
    accountIds,
}: {
    rows: CoaMappingRow[];
    accountIds: Set<string>;
}): CoaMappingRow[] {
    return filterRows(
        rows,
        (row) => row.account !== undefined && accountIds.has(row.id),
    );
}

export function collectAccountRowIds(rows: CoaMappingRow[]): string[] {
    return rows.flatMap((row) =>
        row.account ? [row.id] : collectAccountRowIds(row.children ?? []),
    );
}
